// extracted by mini-css-extract-plugin
export var active = "_c2-7";
export var container = "_c2-0";
export var evenWidth = "_c2-4";
export var large = "_c2-5";
export var outlet = "_c2-8";
export var slide = "_c2-2";
export var small = "_c2-6";
export var tab = "_c2-3";
export var tabs = "_c2-1";